/**
 * Add subscribe/unsubscribe to the NicheListWidget.
 */

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { showAuthModal } from "store/application/application-action";
import { useMyNichesQuery } from "queries";
import { INiche } from "services/types";
import { apiNiches } from "services";
import { IAppState } from "store/app-state";

import { INicheInfo, NicheListWidget } from "./NicheListWidget";

export const NicheListWidgetAlive = (props: {
  title: string;
  link: string;
  className?: string;
  niches: INicheInfo[];
  page: number;
}): JSX.Element => {
  const [following, setFollowing] = useState<string[]>([]);
  const [niches, setNiches] = useState<INicheInfo[]>([]);
  const dispatch = useDispatch();
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);
  const isUserLoggedIn = currentUser && !!Object.entries(currentUser).length;

  const { data: { niches: followedNiches = [] } = {} } = useMyNichesQuery({
    previews: false,
  });

  useEffect(() => {
    if (followedNiches.length) {
      const ids = followedNiches.map((niche: INiche): string => niche.id);
      setFollowing(ids);
    }
  }, [followedNiches]);

  useEffect(() => {
    const nichesList = props.niches.map((n: INicheInfo): INicheInfo => ({
      ...n,
      following: following.indexOf(n.id) >= 0,
    }));

    setNiches(nichesList);
  }, [props.niches, following]);

  const onFollow = async (id: string, follow: boolean) => {
    if (!isUserLoggedIn) {
      dispatch(showAuthModal());
    } else {
      follow ? await followNiche(id) : await unfollowNiche(id);
    }
  };

  const followNiche = async (id: string) => {
    setFollowing((prev) => [...prev, id]);
    await apiNiches.follow(id);
  };

  const unfollowNiche = async (id: string) => {
    setFollowing((prev) => prev.filter((x) => x !== id));
    await apiNiches.unfollow(id);
  };

  return (
    <NicheListWidget
      title={props.title}
      link={props.link}
      className={props.className}
      niches={niches}
      onFollow={onFollow}
      page={props.page}
    />
  );
};
